import QuotePanel from './quote-panel';

export default QuotePanel;
